import { IconNames } from "@blueprintjs/icons";
import { PersistentSection } from "in_queue/components/common/PersistentSection";
import { ScenarioResults } from "in_queue/types/scenarioResultType";
import css from "./charts.module.scss";
import { ScenarioRankingChart } from "./ScenarioRankingChart";
import { SharedUpgradesChart } from "./SharedUpgradesChart";

const CHARTS_SECTION_TITLE = "Charts";
const CHARTS_OPEN_STORAGE_KEY = "iqScenarioChartsOpen";
const CHARTS_SECTION_SUMMARY = "Project ranking and top upgrades";

interface ScenarioChartsProps {
    results: ScenarioResults;
    currentProjectId: string;
    isFullyLoaded: boolean;
}

/**
 * Orchestrator for the Scenario Results page charts. Composes the
 * ranking box plot + the Top Upgrades stacked bar.
 *
 * Must render inside `<ScenarioResultsProvider>`: both child charts read
 * `useScenarioResults()` for the per-scenario project pool, whose rows
 * carry the pipeline's rank alongside the costs.
 */
export const ScenarioCharts: React.FC<ScenarioChartsProps> = ({
    results,
    currentProjectId,
    isFullyLoaded
}) => {
    return (
        <PersistentSection
            title={CHARTS_SECTION_TITLE}
            summary={CHARTS_SECTION_SUMMARY}
            icon={IconNames.TIMELINE_BAR_CHART}
            storageKey={CHARTS_OPEN_STORAGE_KEY}
        >
            <div className={css.scenarioCharts}>
                <ScenarioRankingChart />
                <SharedUpgradesChart
                    upgrades={results.allocatedUpgrades}
                    currentProjectId={currentProjectId}
                    isFullyLoaded={isFullyLoaded}
                />
            </div>
        </PersistentSection>
    );
};
